//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { library } from '@fortawesome/fontawesome-svg-core';
import { faCrown } from '@fortawesome/pro-regular-svg-icons';
import { isProductType } from '@motionelements/core/src/services/catalog.service.js';

library.add(faCrown);

export default {
  name: 'LandingCategoryElements',
  components: {
    SectionHeader: () => import('@/components/landing/SectionHeader.vue'),
    ProductCard: () => import('@motionelements/core/src/components/product-card/ProductCard.vue'),
    ProductCardAudioBackground: () => import('@motionelements/core/src/components/product-card/sections/ProductCardBackgroundAudio.vue'),
    ProductCardAudio: () => import('@motionelements/core/src/components/product-card/ProductCardAudio.vue'),
  },
  props: {
    mediaType: { type: String, required: true },
    elementsType: { type: String, required: true },
    elements: { type: Array, required: true },
  },
  data() {
    return {
      titleClasses: ['latest_elements', 'most_popular'],
    };
  },
  computed: {
    isAudioLayout() {
      return isProductType('audio', this.mediaType);
    },
    detectTitleClasses() {
      if (this.elementsType && this.titleClasses.find(s => s.match(this.elementsType))) {
        return this.titleClasses.find(s => s.match(this.elementsType));
      }
      return this.titleClasses[0];
    },
  },
};
